import globaltypes from '../globaltypes'
import types from './types'
import { groupBy, sortBy, cloneDeep } from 'lodash'

export default {
  [types.getters.shoppingcartitems]: (state, getters, rootState, rootGetters) => {
    if (!state.shoppingcartitems) return []
    const translatePostID = rootGetters[globaltypes.i18n.getters.translatePostID]
    var localizedItems = state.shoppingcartitems.map(item => {
      var productID = translatePostID(item.productID)
      var product = rootGetters[globaltypes.products.getters.product](productID)
      return cloneDeep({
        ...item,
        category: product ? product.categories[0].name : null,
        categoryID: product ? product.categories[0].ID : null,
        cropID: translatePostID(item.cropID),
        productID,
        variationID: translatePostID(item.variationID)
      })
    })
    return localizedItems
  },
  [types.getters.shoppingcartitemsPerCategory]: (state, getters) => {
    return sortBy(groupBy(getters[types.getters.shoppingcartitems], 'categoryID'), x => x[0].category)
  },
  [types.getters.isSycing]: state => {
    return state.syncing
  },
  [types.getters.productCounter]: state => {
    var sum = 0
    cloneDeep(state.shoppingcartitems).forEach(line => {
      sum += parseInt(line.quantity)
    })
    return sum
  }
}
